import { NavLink } from 'react-router';

import { useLanguage } from '../../contexts/language';
import { useNavigation } from '../../hooks/navigation';

import { ProfileLink } from '../profile-link';

import styles from './style.module.css';

// The sections as inline links, then the signed-in person's name at the far
// end, leading to Profile & settings, where Sign out is: the desktop form of
// the menu. NavLink marks the current one with aria-current, which is also what
// the stylesheet uses to highlight it, so the visual state and the announced
// state cannot differ.
export function NavLinks() {
  const { text } = useLanguage();
  const { sections } = useNavigation();

  const links = sections.map(function({ path, label }) {
    return <NavLink key={ path } className={ styles.link } to={ path }>{ text[ label ] }</NavLink>;
  });

  return (
    <div className={ styles.bar }>
      <nav className={ styles.links } aria-label={ text.mainNavigation }>{ links }</nav>

      <ProfileLink/>
    </div>
  );
}
